import { createI18n } from 'vue-i18n';

/**
 * Internationalization object for language translation.
 * @type {object}
 */
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  silentTranslationWarn: true,
  missingWarn: false,
  silentFallbackWarn: true,
  fallbackWarn: false,
  messages: {} //langI.default
});

export default i18n;